import type { CredentialResponse } from './webauthn';

const PAYMENT_TYPE_CODE = 'pix-jsr';
const OPERATION_AUTHENTICATION = 'authentication';

interface AuthenticationPayload {
  readonly contract: string;
  readonly payment_type_code: string;
  readonly operation: string;
  readonly enrollment: {
    readonly authentication: CredentialResponse;
  };
}

interface BuildAuthenticationPayloadParams {
  readonly contract: string;
  readonly credentialData: CredentialResponse;
}

export function buildAuthenticationPayload({
  contract,
  credentialData,
}: BuildAuthenticationPayloadParams): AuthenticationPayload {
  return {
    contract,
    payment_type_code: PAYMENT_TYPE_CODE,
    operation: OPERATION_AUTHENTICATION,
    enrollment: {
      authentication: credentialData,
    },
  };
}
